// React keys should be unique and this function simply stringifies the object,
// and takes the first N chars which would usually be unique enough.
export const hashObject = (json: any) => {
  const temp: any = {};

  Object.entries(json).forEach(([key, value]) => {
    if (value !== undefined && value !== null)
      temp[key] = value;
  });

  return JSON.stringify(temp).substring(0, 32);
};
